var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-version2"},[_c('div',{staticClass:"large-screen-wrap",style:(_vm.largeScreenStyle)},[_c('Header'),_c('Top'),_c('Bottom')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }